import {ChangeDetectionStrategy, Component, inject, OnInit, viewChild} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Title} from '@angular/platform-browser';

import {TabsComponent} from '@components/ui/tabs/tabs.component';
import {RequestTabs} from './request-tabs';
import {TabList} from '@components/ui/tabs/tab-list';

@Component({
    selector: 'app-requests',
    templateUrl: './requests.component.html',
    styleUrls: ['./requests.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TabsComponent, RouterOutlet]
})
export class RequestsComponent implements OnInit {

  readonly tabsComponent = viewChild.required<TabsComponent>('tabsComponent');

  private readonly titleService = inject(Title);

  ngOnInit(): void {
    this.titleService.setTitle('Portal - Requests');
    this.tabsComponent().setTabList(new TabList([RequestTabs.New, RequestTabs.InProgress, RequestTabs.InReview, RequestTabs.Completed]));
  }
}
